import { z } from "zod";

export const REFERRAL_REQUIRES_DETAILS = [
  "doctorOrHealthcareProvider",
  "worksiteOrEmployer",
  "socialMedia",
  "other",
] as const;

export const referredBySchema = z
  .object({
    referredBy: z.string().min(1, "Please select an option"),
    other: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    // "doctorOrHealthcareProvider" deliberately accepts free text without a
    // typeahead pick: the directory only lists partner practices, and a patient
    // referred by any other doctor must still be able to sign up. Without a pick
    // referringPracticeId stays null and the provider roster is unrestricted.
    if (data.referredBy === "other" && !data.other?.trim()) {
      ctx.addIssue({
        path: ["other"],
        message: "Please specify the referral if you selected 'Other'.",
        code: "custom",
      });
    }
  });
